module.exports = __webpack_public_path__ + "static/media/kuro-logo.f8ce27a0.png";